module.exports = __webpack_public_path__ + "static/media/20151231_160946.869f8ba3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-db/20151231_160946.jpg
// module id = 447
// module chunks = 0